import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Globals } from "src/app/wings-mobile/shared/globals/globals";
import { CaseTypeInputValidator } from "src/app/wings-mobile/validators/case-type-input.validator";
import { CustomerService } from "../../../../../services/customer/customer.service";
import { TransportModal } from "../../../../../models/transport-modal.model";
import { DialogModule } from "primeng/dialog";
import { HandheldFormDirective } from "../../../../../directives/handheld-form.directive";
import { SelectModule } from "primeng/select";
import { ButtonDirective } from "primeng/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    'selector': 'export-choose-modal',
    'templateUrl': './export-choose-modal.component.html',
    'styleUrls': ['./export-choose-modal.component.scss'],
    imports: [DialogModule, FormsModule, HandheldFormDirective, ReactiveFormsModule, SelectModule, ButtonDirective, TranslatePipe]
})
export class ExportChooseModalComponent implements OnInit {

	@Input() routeModal: string;

	@Output() onClose = new EventEmitter();
	@Output() onModalConfirmed = new EventEmitter();
	@Output() onModalError = new EventEmitter();

	formGroup: UntypedFormGroup;
	modals: TransportModal[];

	constructor(private globals: Globals,
		private caseValidator: CaseTypeInputValidator,
		private customerService: CustomerService
	) {
		this.globals = globals;
		this.caseValidator = caseValidator;
		this.customerService = customerService;
	}

	ngOnInit(): void {
		this.startFormGroup();
		this.getTransportModals();
	}

	startFormGroup() {
		this.formGroup = new UntypedFormGroup({
			transportModal: new UntypedFormControl(this.routeModal, Validators.required)
		})
	}

	getTransportModals() {
		this.customerService.getModalByCountry(this.globals.user.country, this.globals.user.language).subscribe({
			next: res => {
				this.modals = res;
			},
			error: err => {
				if (err === 404) {
					this.getModalError('modal.transportModalNotFound');
				} else {
					this.getModalError('modal.operationNotPerformed');
				}
			}
		})
	}

	closeModal() {
		this.onClose.emit();
	}

	confirmModal() {
		this.onModalConfirmed.emit(this.formGroup.controls['transportModal'].value);
	}

	getModalError(message: string) {
		this.onClose.emit();
		this.onModalError.emit(message);
	}
}

